var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.errored
      ? _c("section", { staticClass: "overlay overlay-text" }, [_vm._m(0)])
      : _c(
          "section",
          [
            _vm.loading
              ? _c("div", { staticClass: "overlay" }, [
                  _c("p", { staticClass: "overlay-text loading-text" }, [
                    _vm._v("Loading...")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "loading-spacer" },
                    [
                      _c("vue-loading", {
                        attrs: {
                          type: "spiningDubbles",
                          color: "#FFF",
                          size: { width: "100px", height: "100px" }
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("Header"),
            _vm._v(" "),
            _c("div", { staticClass: "date" }, [
              _c(
                "span",
                { staticClass: "parenthesis", on: { click: _vm.previousDay } },
                [_vm._v("＜")]
              ),
              _c("span", { staticClass: "day" }, [_vm._v(_vm._s(_vm.date))]),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isNextDay,
                      expression: "isNextDay"
                    }
                  ],
                  staticClass: "parenthesis",
                  on: { click: _vm.nextDay }
                },
                [_vm._v("＞")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "nominal" }, [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selected,
                    expression: "selected"
                  }
                ],
                staticClass: "selected-foodstuff",
                attrs: {
                  src: require("@/assets/meal_history/アセット 1@2x.png"),
                  width: "902",
                  height: "220",
                  loding: "lazy"
                }
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.selected,
                    expression: "!selected"
                  }
                ],
                staticClass: "nomal-foodstuff",
                attrs: {
                  src: require("@/assets/meal_history/アセット 3@2x.png"),
                  width: "561",
                  height: "142",
                  loding: "lazy"
                },
                on: { click: _vm.showRecordsMain }
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.selected,
                    expression: "!selected"
                  }
                ],
                staticClass: "selected-water",
                attrs: {
                  src: require("@/assets/meal_history/アセット 38@2x.png"),
                  width: "902",
                  height: "220",
                  loding: "lazy"
                }
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selected,
                    expression: "selected"
                  }
                ],
                staticClass: "nomal-water",
                attrs: {
                  src: require("@/assets/meal_history/アセット 37@2x.png"),
                  width: "337",
                  height: "142",
                  loding: "lazy"
                },
                on: { click: _vm.showWaterIntake }
              })
            ]),
            _vm._v(" "),
            _vm.selected
              ? _c(
                  "div",
                  { staticClass: "meal-records-main" },
                  [
                    _c("div", { staticClass: "compartment" }),
                    _vm._v(" "),
                    _vm._l(_vm.mealslist, function(meals, index) {
                      return _c(
                        "div",
                        {
                          key: meals.id,
                          staticClass: "meals-list",
                          class: ["foods-" + index],
                          attrs: { id: index }
                        },
                        [
                          _c("img", {
                            key: "username",
                            staticClass: "meal-img",
                            attrs: { src: meals.image },
                            on: {
                              touchstart: function($event) {
                                $event.preventDefault()
                                return _vm.ingestedFood(index)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "meal-right" }, [
                            !_vm.isActive
                              ? _c("img", {
                                  style: { display: meals.display },
                                  attrs: { src: meals.right }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isActive
                              ? _c("img", {
                                  style: { display: meals.display },
                                  attrs: { src: meals.editRight },
                                  on: {
                                    touchstart: function($event) {
                                      $event.preventDefault()
                                      return _vm.ingestedFood(index)
                                    }
                                  }
                                })
                              : _vm._e()
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.selected,
                    expression: "!selected"
                  }
                ],
                staticClass: "water-intake-main"
              },
              [
                _c(
                  "div",
                  { staticClass: "water-amount" },
                  [
                    _vm._l(_vm.teaCups, function(teaCup, index) {
                      return _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isWaterActive,
                            expression: "!isWaterActive"
                          }
                        ],
                        staticClass: "tea-drink",
                        attrs: { src: teaCup.img, id: index },
                        on: {
                          click: function($event) {
                            return _vm.pushedTeaDrink(index + 1)
                          }
                        }
                      })
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.teaCups, function(teaCup, index) {
                      return _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isWaterActive,
                            expression: "isWaterActive"
                          }
                        ],
                        staticClass: "tea-drink",
                        attrs: { src: teaCup.editImg, id: index },
                        on: {
                          click: function($event) {
                            return _vm.pushedTeaDrink(index + 1)
                          }
                        }
                      })
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "hand-tea-drink",
                      attrs: {
                        src: require("@/assets/meal_entry/アセット 29@2x.png"),
                        width: "335",
                        height: "457",
                        loading: "lazy"
                      }
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._m(1)
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "foods-intake" }, [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selected,
                    expression: "selected"
                  }
                ],
                attrs: {
                  src: require("@/assets/meal_history/アセット 30@2x.png"),
                  width: "1177",
                  height: "844",
                  loding: "lazy"
                }
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.selected,
                    expression: "!selected"
                  }
                ],
                attrs: {
                  src: require("@/assets/meal_history/アセット 31@2x.png"),
                  width: "1177",
                  height: "844",
                  loding: "lazy"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selected,
                      expression: "selected"
                    }
                  ]
                },
                [
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.mealslist[0].ingested,
                          expression: "!mealslist[0].ingested"
                        }
                      ]
                    },
                    [
                      _c("img", {
                        staticClass: "facial-expression",
                        attrs: {
                          src: require("@/assets/home/アセット 25@2x.png"),
                          width: "340",
                          height: "341",
                          loding: "lazy"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.mealslist[0].ingested,
                          expression: "mealslist[0].ingested"
                        }
                      ]
                    },
                    [
                      _c("img", {
                        staticClass: "facial-expression",
                        attrs: {
                          src: require("@/assets/home/アセット 23@2x.png"),
                          width: "340",
                          height: "341",
                          loding: "lazy"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "score" }, [
                    _vm._v(_vm._s(_vm.targetFoodsIngested.score))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.selected,
                      expression: "!selected"
                    }
                  ]
                },
                [
                  _c("p", { staticClass: "ingested-water-cup" }, [
                    _vm._v(_vm._s(_vm.ingestedWater))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ingested-water-amount" }, [
                    _vm._v(_vm._s(_vm.targetFoodsIngested.water))
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "img-style" }, [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selected,
                      expression: "selected"
                    }
                  ],
                  staticClass: "editing-meal-records history-float-right",
                  attrs: {
                    src: require("@/assets/meal_history/アセット 17@2x.png")
                  },
                  on: { click: _vm.editingMealRecords }
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.selected,
                      expression: "!selected"
                    }
                  ],
                  staticClass: "editing-water-intake history-float-right",
                  attrs: {
                    src: require("@/assets/meal_history/アセット 40@2x.png")
                  },
                  on: { click: _vm.editingWaterRecords }
                })
              ]),
              _vm._v(" "),
              _c("div", [
                _c("img", {
                  staticClass: "weekly-table history-float-right",
                  attrs: {
                    src: require("@/assets/meal_history/アセット 18@2x.png"),
                    width: "860",
                    height: "239",
                    loding: "lazy"
                  },
                  on: { click: _vm.weeklyTable }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clear-both" }),
            _vm._v(" "),
            _c("Footer"),
            _vm._v(" "),
            _c("InputEditFoods", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isActive,
                  expression: "isActive"
                }
              ],
              attrs: { isfirstRecord: _vm.isfirstRecord },
              on: {
                "handle-hide": _vm.hideEditFoods,
                "handle-foods-put": _vm.foodsIngestedPutApi,
                "handle-foods-post": _vm.foodsIngestedPostApi
              }
            }),
            _vm._v(" "),
            _c("InputEditWater", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isWaterActive,
                  expression: "isWaterActive"
                }
              ],
              attrs: { isfirstRecord: _vm.isfirstRecord },
              on: {
                "handle-hide": _vm.hideEditWater,
                "handle-water-put": _vm.waterIngestedPutApi,
                "handle-water-post": _vm.waterIngestedPostApi
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "overlay-text" }, [
      _vm._v("申し訳ありませんが、"),
      _c("br"),
      _vm._v("現時点ではこの情報を取得できません。"),
      _c("br"),
      _vm._v("しばらくしてからもう一度お試しください")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "Intake-target-text" }, [
        _vm._v("※１日の摂取目標は7杯(約1000ml)")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6e154c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6e154c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/History.vue
// module id = null
// module chunks = 